import React from 'react'
import TimeTriggerDropdown from './time-trigger-dropdown'

const MessageRow = props => {
  const {message, onUpdate, onEdit, onDelete} = props

  return (
    <tr>
      <td>
        <div className='message-title'>
          <span>{message.title}</span>
        </div>
      </td>
      <td>
        <div className='message-locations'>
          {JSON.stringify(message.locations) == '[0]' ? 'All' : message.locations.length || 'No location'}
        </div>
      </td>
      <td>
        <TimeTriggerDropdown
          message={message}
          onTriggerChange={e => onUpdate({id: message.id, ...e})}
        />
      </td>
      <td>
        <input
          checked={message.zipwhip || false}
          name='zipwhip'
          type='checkbox'
          onChange={e => onUpdate({id: message.id, zipwhip: e.target.checked})}
        />
      </td>
      <td>
        <input
          checked={message.direct_message || false}
          name='direct_message'
          type='checkbox'
          onChange={e => onUpdate({id: message.id, direct_message: e.target.checked})}
        />
      </td>
      <td>
        <input
          checked={message.group_chat || false}
          name='group_chat'
          type='checkbox'
          onChange={e => onUpdate({id: message.id, group_chat: e.target.checked})}
        />
      </td>
      <td>
        <input
          checked={message.sms || false}
          name='sms'
          type='checkbox'
          onChange={e => onUpdate({id: message.id, sms: e.target.checked})}
        />
      </td>
      <td>
        <div
          onClick={() => onEdit(message)}
          className='edit-auto-message' />
      </td>
      <td>
        <div
          onClick={() => onDelete(message)}
          className='delete-auto-message'>
            <i className='fa fa-trash-o' />
        </div>
      </td>
    </tr>
  )
}

export default MessageRow
